/*
 * Created by Ali Simsek on 5/14/20, 2:02 PM
 * Copyright (c) 2020 Carla Car Rental, Inc. All rights reserved.
 * Last modified 5/13/20, 6:32 PM
 */

import * as PropTypes from 'prop-types'
import { CarlinPropTypes } from '../../entities'
import Downshift from 'downshift'
import React from 'react'
import { AsyncDownshift } from './AsyncDownshift'
import {
  AsyncMobileMenu,
  CheckboxDownDS,
  InputDS,
  LabelDS,
  MenuDS,
  MobileMenuDS,
  SelectContainerDS,
  SelectDS
} from './components'

export { AsyncDownshift }
export * from './components'

export const selectPropTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  value: CarlinPropTypes.SelectItem,
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string
}

export const asyncSelectPropTypes = {
  value: CarlinPropTypes.SelectItem,
  onChange: PropTypes.func,
  loadItems: PropTypes.func,
  label: PropTypes.string
}

export const CarlaSelect = ({ value, items, label, placeholder, ...props }) => (
  <Downshift selectedItem={value} itemToString={(item) => item.label || ''} {...props}>
    {({
      getLabelProps,
      getRootProps,
      getInputProps,
      getToggleButtonProps,
      getMenuProps,
      getItemProps,
      isOpen,
      selectedItem,
      ...props
    }) => (
      <SelectContainerDS {...getRootProps()} {...props}>
        <LabelDS {...getLabelProps()}>{label}</LabelDS>
        <InputDS type='button' {...getInputProps()} {...getToggleButtonProps()} />
        <CheckboxDownDS />
        <MenuDS className='items' isOpen={isOpen} {...getMenuProps()}>
          {items.map((item, index) => (
            <li className='item' {...getItemProps({ key: item.value, item, index })}>
              {item.label}
            </li>
          ))}
        </MenuDS>
      </SelectContainerDS>
    )}
  </Downshift>
)
CarlaSelect.propTypes = selectPropTypes

export const CarlaMobileSelect = ({ items, value, onChange, label, placeholder, ...props }) => {
  return (
    <Downshift
      selectedItem={value}
      onChange={onChange}
      items={items}
      itemToString={(item) => (item ? item.label : '')}
      {...props}
    >
      {({
        getLabelProps,
        getRootProps,
        getInputProps,
        getToggleButtonProps,
        getMenuProps,
        getItemProps,
        isOpen,
        closeMenu,
        selectedItem,
        ...props
      }) => {
        return (
          <SelectContainerDS {...getRootProps()} {...props}>
            <LabelDS {...getLabelProps()}>{label}</LabelDS>
            <SelectDS type='button' {...getToggleButtonProps()}>
              {selectedItem ? selectedItem.label : placeholder}
              <CheckboxDownDS />
            </SelectDS>
            <MobileMenuDS
              {...{ items, label, placeholder }}
              {...{ isOpen, selectedItem, getMenuProps, getItemProps, closeMenu }}
            />
          </SelectContainerDS>
        )
      }}
    </Downshift>
  )
}
CarlaMobileSelect.propTypes = selectPropTypes

export const CarlaAsyncMobileSelect = ({
  value,
  inputValue,
  onChange,
  loadItems,
  label,
  placeholder,
  errorText,
  ...props
}) => (
  <AsyncDownshift value={value} onChange={onChange} loadItems={loadItems} {...props}>
    {({
      getLabelProps,
      getRootProps,
      getInputProps,
      getToggleButtonProps,
      getMenuProps,
      getItemProps,
      isOpen,
      selectedItem,
      clearSelection,
      closeMenu,
      isLoading,
      error,
      items
    }) => (
      <SelectContainerDS {...getRootProps()} {...props}>
        <LabelDS {...getLabelProps()}>{label}</LabelDS>
        <SelectDS type='button' {...getToggleButtonProps()}>
          {selectedItem ? selectedItem.label : placeholder}
        </SelectDS>
        <AsyncMobileMenu
          {...{ label, placeholder, errorText }}
          {...{ isOpen, isLoading, error, items, closeMenu, getMenuProps, getItemProps, getInputProps }}
        />
      </SelectContainerDS>
    )}
  </AsyncDownshift>
)
CarlaAsyncMobileSelect.propTypes = asyncSelectPropTypes
